export default __webpack_public_path__ + "static/bestview-grounds2-thumb-5c1b34055ee2f6cc7d6ddc41aac49aac.jpg";